module.exports = __webpack_public_path__ + "static/media/Wheel of fortune 2.2f630c3f.webp";